<template>
    <router-link :to="entry.link" :title="entry.title" class="clean">
        <div class="card-entry" v-bind:class="{ 'uk-card uk-card-default uk-box-shadow-hover-large' : !noCard, 'cardless': noCard }">

            <div class="uk-card-media-top">
                <div class="ar16x9 uk-background-cover" v-bind:style="{ backgroundImage: `url(${entry.thumbnail})` }" :alt="entry.title"></div>
            </div>

            <div class="uk-text-left" v-bind:class="{ 'uk-card-body' : !noCard }">
                <div class="match-height">
                    <label v-if="!hideYear" class='uk-margin-top'>{{entry.year.title}}</label>
                    <h3 class="uk-card-title"><b>{{entry.title}}</b></h3>
                </div>
                <span v-if="!!entry.prize && entry.prize.id > 0" class="text-yellow entry-prize">${{parseInt(entry.prize.prize).toLocaleString('en-US')}} {{entry.prize.title}}</span>
            </div>

            <!-- <router-link :to="entry.Prize" :alt="entry.title" class="uk-button uk-button-primary uk-width-1-1">View entry</router-link> -->

        </div>
    </router-link>
</template>

<script>
export default {
    props: ['entry', 'hideYear', 'noCard']
}
</script>
